import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/client/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/ui/card";

/** Shown when a token-bearing link (invite / reset) is missing, expired, or unknown. */
export function InvalidTokenCard({ title, description }: { title: string; description: string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button asChild variant="outline" className="w-full">
          <Link to="/login">Back to sign in</Link>
        </Button>
      </CardContent>
    </Card>
  );
}

/** Placeholder shown while a token-bearing link is being validated on load. */
export function TokenCheckingCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Checking your link…</CardTitle>
        <CardDescription>One moment while we verify this link.</CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center py-2" aria-busy="true">
        <Loader2 className="text-muted-foreground size-5 animate-spin" />
        <span className="sr-only">Loading</span>
      </CardContent>
    </Card>
  );
}
